import request from '@/utils/request'


// 查询物流时效配置列表
export function listShippingTimeEffect(query) {
  return request({
    url: '/shipping/shipping/time/effect/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询物流时效配置分页
export function pageShippingTimeEffect(query) {
  return request({
    url: '/shipping/shipping/time/effect/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询物流时效配置详细
export function getShippingTimeEffect(data) {
  return request({
    url: '/shipping/shipping/time/effect/detail',
    method: 'get',
    params: data
  })
}

// 新增物流时效配置
export function addShippingTimeEffect(data) {
  return request({
    url: '/shipping/shipping/time/effect/add',
    method: 'post',
    data: data
  })
}

// 修改物流时效配置
export function updateShippingTimeEffect(data) {
  return request({
    url: '/shipping/shipping/time/effect/edit',
    method: 'post',
    data: data
  })
}

// 删除物流时效配置
export function delShippingTimeEffect(data) {
  return request({
    url: '/shipping/shipping/time/effect/delete',
    method: 'post',
    data: data
  })
}
